import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function PromoBanner() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="py-16 bg-white" data-id="element-328">
      <div className="max-w-6xl mx-auto px-6" data-id="element-329">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="flex flex-col md:flex-row items-center gap-8" data-id="element-330">
          <div className="md:w-1/3" data-id="element-331">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rGG1hhvU7JXTG53fEUgwbM/TEFTCF_Canada_%28Publication_Facebook%29.png" alt="TEF/TCF Canada Preparation" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-332" />
          </div>
          <div className="md:w-2/3" data-id="element-333">
            <h3 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-334">
              TEF/TCF Canada <span className="text-green-600" data-id="element-335">Preparation</span>
            </h3>
            <p className="text-lg text-slate-600 mb-4" data-id="element-336">
              Specialized preparation courses designed to help you achieve the
              scores you need for Canadian immigration. Our comprehensive
              program includes:
            </p>
            <ul className="space-y-2 text-slate-600" data-id="element-337">
              <li className="flex items-center gap-2" data-id="element-338">
                <span className="w-2 h-2 bg-green-600 rounded-full" data-id="element-339" />
                Expert instruction from certified TEF/TCF examiners
              </li>
              <li className="flex items-center gap-2" data-id="element-340">
                <span className="w-2 h-2 bg-green-600 rounded-full" data-id="element-341" />
                Mock exams and personalized feedback
              </li>
              <li className="flex items-center gap-2" data-id="element-342">
                <span className="w-2 h-2 bg-green-600 rounded-full" data-id="element-343" />
                Proven strategies for all four competencies
              </li>
              <li className="flex items-center gap-2" data-id="element-344">
                <span className="w-2 h-2 bg-green-600 rounded-full" data-id="element-345" />
                Flexible scheduling to fit your timeline
              </li>
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}